export default __webpack_public_path__ + "static/media/halu-background.70f0438e.png";